import { createSlice } from "@reduxjs/toolkit";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";


const initialState = {
    data: null,
};

const apiUrl = process.env.REACT_APP_API_URL;

export const analyticsSlice = createSlice({
    name: "analytics",
    initialState,
    reducers: {
        setAnalytics: (state) => {
            state.data = state.payload;
        },
    },
});

// Action creators are generated for each case reducer function
export const { setAnalytics } = analyticsSlice.actions;

export default analyticsSlice.reducer;

export const analyticsApi = createApi({
    reducerPath: "analyticsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: apiUrl, // Utilisation du proxy
        prepareHeaders: (headers, { getState }) => {
            const token = JSON.parse(localStorage.getItem('auth'))?.jwt;

            // Si un token est disponible, ajoutez-le aux en-têtes
            if (token) {
                headers.set("authorization", `Bearer ${token}`);
            }
            headers.set('Content-type', 'application/json');
            headers.set('Accept', 'application/json');
            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAnalytics: builder.query({
            query: ({ page, size }) => ({
                url: `/analytics?pagination[page]=${page}&pagination[pageSize]=${size}&sort=id:desc`, // Appel via le proxy


            }),
        }),


    }),
});

// Export hooks pour une utilisation dans les composants fonctionnels
export const { useGetAnalyticsQuery } = analyticsApi;

